import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './virtual-fence-circle.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VirtualFenceCircleDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const virtualFenceCircleEntity = useAppSelector(state => state.virtualFenceCircle.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="virtualFenceCircleDetailsHeading">
          <Translate contentKey="fleetSenseApp.virtualFenceCircle.detail.title">VirtualFenceCircle</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.name">Name</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.description">Description</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.description}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.color">Color</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.color}</dd>
          <dt>
            <span id="latitude">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.latitude">Latitude</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.latitude}</dd>
          <dt>
            <span id="longitude">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.longitude">Longitude</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.longitude}</dd>
          <dt>
            <span id="radius">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.radius">Radius</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.radius}</dd>
          <dt>
            <span id="activated">
              <Translate contentKey="fleetSenseApp.virtualFenceCircle.activated">Activated</Translate>
            </span>
          </dt>
          <dd>{virtualFenceCircleEntity.activated ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.virtualFenceCircle.company">Company</Translate>
          </dt>
          <dd>{virtualFenceCircleEntity.company ? virtualFenceCircleEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/virtual-fence-circle" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/virtual-fence-circle/${virtualFenceCircleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VirtualFenceCircleDetail;
